export default {
    CheckingLoyalty: `/api/discounts/checkingLoyalty`
}